
import { getBomCSVName } from 'bom/utils/bomCSVNames';
import React from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper } from '@mui/material';
import { FETCH_STATIC } from '__common/components/FetchStatics/fetchStaticsActions';
import { dispatch } from '__common/store';
import SVG from 'react-inlinesvg';
import { getPEStampPDFName } from 'peStamp/utils/pestampPDFNames';
import { shouldDisplayPeOrCombinedPeStampButton } from 'combineProjects/CombineProjectsHelper';

type Props = {
  data: any[],
  isStaff: boolean,
};

export default class CombinedProjectsTable extends React.Component<Props> {

  fetchBom = projectId => {
    dispatch(
      FETCH_STATIC(`${getBomCSVName(projectId)}.csv`, 'text/csv', `download/bom/`, { projectId }),
    );
  }

  fetchPEStamp = projectId => {
    dispatch(
      FETCH_STATIC(`${getPEStampPDFName(projectId)}.pdf`, 'text/pdf', `download/pestamp/`, { projectId }),
    );
  }
  
  render() {
    const { data, isStaff } = this.props;
    return (
      <TableContainer component={Paper}>
        <Table className="combined-projects-parts-table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '80px' }}>PROJECT ID</TableCell>
              <TableCell sx={{ width: '140px' }}>PROJECT NAME</TableCell>
              <TableCell sx={{ width: '130px' }}>CREATED</TableCell>
              <TableCell sx={{ width: '80px' }}>MFG</TableCell>
              <TableCell sx={{ width: '120px' }}>MODEL</TableCell>
              <TableCell sx={{ width: '150px' }}>CLIENT NAME</TableCell>
              <TableCell sx={{ width: '130px' }}>ADDRESS</TableCell>
              <TableCell sx={{ width: '70px' }}>ZIP</TableCell>
              <TableCell sx={{ width: '80px' }}>MODULES</TableCell>
              <TableCell sx={{ width: '80px' }}>WATTS</TableCell>
              <TableCell sx={{ width: '90px' }}>LIST PRICE</TableCell>
              <TableCell sx={{ width: '120px' }}>DOWNLOAD BOM</TableCell>
              {shouldDisplayPeOrCombinedPeStampButton(isStaff) ? (
                <TableCell sx={{ width: '150px' }}>DOWNLOAD PE STAMP</TableCell>
              ) : null}
            </TableRow>
          </TableHead>
      <TableBody>
        {data.map((project, index) => (
          <TableRow key={index}>
            <TableCell sx={{ width: '80px' }}>{project.project_id}</TableCell>
            <TableCell sx={{ width: '140px' }}>{project.project_name}</TableCell>
            <TableCell sx={{ width: '130px' }}>{project.created}</TableCell>
            <TableCell sx={{ width: '80px' }}>{project.panel_mfg}</TableCell>
            <TableCell sx={{ width: '120px' }}>{project.panel_model}</TableCell>
            <TableCell sx={{ width: '150px' }}>{project.client_name}</TableCell>
            <TableCell sx={{ width: '130px' }}>{project.client_address}</TableCell>
            <TableCell sx={{ width: '70px' }}>{project.zipcode}</TableCell>
            <TableCell sx={{ width: '80px' }}>{project.total_modules}</TableCell>
            <TableCell sx={{ width: '80px' }}>{project.total_watts}</TableCell>
            <TableCell sx={{ width: '90px' }}>{project.total_price}</TableCell>
            <TableCell sx={{ width: '120px' }}>
            <button onClick={() => this.fetchBom(project.project_id)}><i className="md-icon material-icons md-text--inherit">download</i></button>
           </TableCell>
           {shouldDisplayPeOrCombinedPeStampButton(isStaff) ? (
            <TableCell sx={{ width: '150px' }}>
              <button onClick={() => this.fetchPEStamp(project.project_id)}><i className="md-icon material-icons md-text--inherit">download</i></button>
            </TableCell>
          ) : null}
          </TableRow>
        ))}
      </TableBody>
        </Table>
      </TableContainer>
    );
  }
}
